import React from 'react';
import PropTypes from 'prop-types';
import { ChevronDown } from '@dbk/ui-icons';
import { bemHelper, pure } from '@dbk/ui-react-utils';
import classnames from 'classnames';

import styles from './dropdown.css';

const bem = bemHelper(styles, 'dropdown');

const DropdownButton = (props) => {
  const { id, value, selected, renderSelectedOption } = props;
  const textClass = classnames(bem('text'), {
    [bem('placeholder')]: !selected,
  });

  const renderedValue = renderSelectedOption ? (
    renderSelectedOption(value)
  ) : (
    <span id={id} className={textClass} aria-live="polite" title={value}>
      {value}
    </span>
  );

  return (
    <div className={bem('button-wrapper')}>
      {renderedValue}
      <ChevronDown
        className={bem('arrow')}
        width={12}
        height={7}
        color="#00A7F0"
      />
    </div>
  );
};

DropdownButton.propTypes = {
  value: PropTypes.string,
  id: PropTypes.string,
  renderSelectedOption: PropTypes.func,
  selected: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

DropdownButton.defaultProps = {
  value: 'Please select',
  id: undefined,
  renderSelectedOption: undefined,
  selected: false,
};

export default pure(DropdownButton);
